import { gql } from '@apollo/client';

// TODO: оптимизировать queries, добавить fragments
export const GET_COMPANY = gql`
	query GetCompany($id: Identifier!) {
		company(id: $id) {
			id
			gorkoId
			city {
				name
			}
			name
			isGroup
			salesTarget
			commissionPriority
			status {
				id
				name
				code
				group {
					id
					name
					code
				}
			}
			statusAt
			cache {
				postponedUntil
			}
			groupLinksAsMember {
				id
				group {
					id
					name
					groupLinksAsGroup {
						unlinked
						company {
							id
							gorkoId
							name
							city {
								name
							}
							salesTarget
							commissionPriority
							params {
								id
								knownFrom
								email
								sitesInternal {
									gorko
									bpm
									wiki
								}
								sitesExternal
							}
							worth {
								id
								value
								valueAuto
								wedding
								weddingAuto
								birthday
								birthdayAuto
								corporative
								newYear
								newYearAuto
								graduation
							}
						}
					}
				}
				company {
					id
					gorkoId
					name
					city {
						name
					}
				}
				unlinked
				linkedAt
				unlinkedAt
			}
			groupLinksAsGroup {
				id
				group {
					id
					name
				}
				company {
					id
					gorkoId
					name
					city {
						name
					}
					salesTarget
					commissionPriority
					params {
						id
						knownFrom
						email
						sitesInternal {
							gorko
							bpm
							wiki
						}
						sitesExternal
					}
					worth {
						id
						value
						valueAuto
						wedding
						weddingAuto
						birthday
						birthdayAuto
						corporative
						newYear
						newYearAuto
						graduation
					}
				}
				unlinked
				linkedAt
				unlinkedAt
			}
			params {
				id
				knownFrom
				email
				sitesInternal {
					gorko
					bpm
					wiki
				}
				sitesExternal
				createdAt
				updatedAt
			}
			objections {
				id
				company {
					name
				}
				createdBy {
					name
				}
				type {
					id
					name
				}
				solved
				solvedAt
				comment
				createdAt
			}
			calls {
				id
				externalId
				company {
					name
				}
				createdBy {
					name
				}
				createdAt
				updatedAt
			}
			documents {
				id
				company {
					name
				}
				file {
					id
					mimeType
					size
				}
				name
				isDeleted
				deletedAt
				createdAt
			}
			contracts {
				id
				company {
					name
				}
				file {
					id
					mimeType
					size
				}
				name
				signed
				isDeleted
				deletedAt
				createdAt
			}
			personalContacts {
				id
				firstName
				lastName
				middleName
				position
				responsiblePerson
				comment
				active
				numbers {
					number
					kind
					comment
					isDeleted
				}
				createdAt
				updatedAt
			}
			generalNumbers {
				id
				number
				active
				comment
				createdAt
				updatedAt
			}
			worth {
				id
				company {
					name
				}
				required
				value
				valueAuto
				wedding
				weddingAuto
				birthday
				birthdayAuto
				corporative
				newYear
				newYearAuto
				graduation
			}
			eventSelections {
				year
				events {
					key
					name
					gorkoId
					selectionCount
				}
			}
			createdAt
			updatedAt
		}
	}
`;
